import { render, staticRenderFns } from "./CostHistory.vue?vue&type=template&id=9f2d6ab2&"
import script from "./CostHistory.vue?vue&type=script&lang=js&"
export * from "./CostHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports